// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"cJ3ve","base":"_1H61N"};